import { useState, useEffect, useRef } from "react";
import { log } from "../../../../commonfunctions/logger";
import { Address, AlertContent } from "../../../../interfaces/interfaces";
import { AlertType } from "../../../../interfaces/enums";
import { addressService } from "../services/addressService";

export const useAddressBook = () => {
  const [savedAddresses, setSavedAddresses] = useState<Address[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [toast, setToast] = useState<AlertContent | null>(null);
  const isMounted = useRef(true);

  useEffect(() => {
    fetchAddresses();

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAddresses = async () => {
    setIsLoading(true);

    try {
      const data = await addressService.fetchAll();

      if (isMounted.current) {
        setIsLoading(false);
        if (data.length === 0) {
          setSavedAddresses([]);
        } else {
          setSavedAddresses(data);
        }
      }
    } catch (error) {
      if (isMounted.current) {
        log(error, "Failed to fetch saved addresses in /preferences");
        setIsLoading(false);
        setToast({
          message: "Failed to load addresses. Please try again later.",
          type: AlertType.Error,
        });
        setSavedAddresses([]);
      }
    }
  };

  const deleteAddress = async (address: Address) => {
    if (!address || !address.id) return;

    if (!window.confirm(`Are you sure you want to delete "${address.ship_to_name}"?`)) {
      return;
    }

    try {
      await addressService.delete(address.id);
      setToast({
        message: "Address successfully deleted.",
        type: AlertType.Success,
      });
      fetchAddresses();
    } catch (error) {
      log(error, "Failed to delete address in /preferences");
      setToast({
        message: "Failed to delete address. Please try again.",
        type: AlertType.Error,
      });
    }
  };

  return {
    savedAddresses,
    isLoading,
    toast,
    setToast,
    fetchAddresses,
    deleteAddress,
  };
};
